import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { mostrarNotif } from "./useNotificacoes";
import { versaoMaisNova } from "../utils/versaoApp";

const isAndroidApp = () => window.Capacitor?.getPlatform?.() === "android";

// O CI publica a versão em config/assinatura. O aviso fica na central do
// Android, uma vez por versão, e só abre Downloads quando o usuário toca.
export function useAvisoAtualizacao(uid, versaoAtual) {
  useEffect(() => {
    if (!uid || !isAndroidApp()) return;
    let cancelado = false;
    let verificando = false;
    const verificar = async () => {
      if (cancelado || verificando) return;
      verificando = true;
      try {
        const snap = await getDoc(doc(db, "config", "assinatura"));
        if (cancelado || !snap.exists()) return;
        const { apkVersion } = snap.data();
        if (!versaoMaisNova(apkVersion, versaoAtual)) return;
        const chave = `aviso_atualizacao_sistema_${apkVersion}`;
        try {
          if (localStorage.getItem(chave)) return;
        } catch { /* sem localStorage: avisa mesmo assim */ }
        const exibiu = await mostrarNotif(
          "Atualização do Print Control",
          `Nova versão v${apkVersion}. Toque para conferir em Configurações → Downloads.`,
          { type: "app_update", version: apkVersion, recipientId: uid }
        );
        // Permissão negada ou falha não consome o aviso: tenta no próximo retorno.
        if (exibiu && !cancelado) {
          try { localStorage.setItem(chave, "1"); } catch {}
        }
      } catch { /* offline: tenta novamente ao voltar ao app */ }
      finally { verificando = false; }
    };
    const aoRetomar = () => { if (document.visibilityState !== "hidden") verificar(); };
    verificar();
    window.addEventListener("focus", aoRetomar);
    window.addEventListener("online", aoRetomar);
    document.addEventListener("visibilitychange", aoRetomar);
    return () => {
      cancelado = true;
      window.removeEventListener("focus", aoRetomar);
      window.removeEventListener("online", aoRetomar);
      document.removeEventListener("visibilitychange", aoRetomar);
    };
  }, [uid, versaoAtual]);
}
